import { Eye, EyeOff } from "lucide-react";

import { Button } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";

export const ChatSessionFollowModeButton = ({
  enabled,
  onClick,
}: {
  enabled?: boolean;
  onClick: (e: React.MouseEvent) => void;
}) => (
  <BasicTooltip content={enabled ? "Stop following agent" : "Follow agent"}>
    <Button
      variant={enabled ? "blue" : "ghost"}
      size="icon"
      onClick={onClick}
      className="group/button relative h-7 w-7"
      type="button"
    >
      <EyeOff
        className={cn("absolute h-4 w-4 opacity-0", enabled && "group-hover/button:opacity-100")}
      />
      <Eye className={cn("h-4 w-4 opacity-100", enabled && "group-hover/button:opacity-0")} />
    </Button>
  </BasicTooltip>
);
